import { Outlet, useMatch } from "react-router-dom";
import Sidebar from "./Sidebar/Sidebar.js";
import "./../styles/App.css";

function Layout() {
    const matchesProductDetailsView = useMatch( '/products/:handle' );
    const hideSidebar = matchesProductDetailsView !== null;

    return (
        <div className="layout">
            { !hideSidebar && <Sidebar /> }
            <main className="main-content">
                <Outlet />
            </main>
        </div>
    );
}

export default Layout;